"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const NewsCategory_vue_1 = __importDefault(require("../../pages/newsCategory/NewsCategory.vue"));
const NewsArticle_vue_1 = __importDefault(require("../../pages/newsArticle/NewsArticle.vue"));
exports.default = [
    {
        name: 'news_category',
        path: '/news-category/:code',
        component: NewsCategory_vue_1.default,
        meta: { requiresAuth: true, title: 'News Category' }
    },
    {
        name: 'news_article',
        path: '/news-article/:id(\\d+)',
        component: NewsArticle_vue_1.default,
        meta: { requiresAuth: true, title: 'News Article' }
    },
];
